import React, { useMemo } from 'react';
import styles from './Common.module.scss';
import { format, parseISO } from 'date-fns';
import { Avatar } from '@material-ui/core';
import User from 'infrastructure/User';
import Organization from 'infrastructure/Organization';

const RoleplayHeader = ({ roleplayView = {}, leadView = false, isForSubmitView }) => {
  const isSelfAssigned = useMemo(() => {
    if (!roleplayView) return false;

    const assignedBy = User.getUserName(roleplayView?.assigned_by_user);
    const userName = User.getUserName(Organization.getUserInfo());

    return roleplayView?.self_assigned === true || assignedBy === userName;
  }, [roleplayView]);

  const label = useMemo(() => {
    return Organization.isRep() && isSelfAssigned ? 'Created by you ' : 'Manager';
  }, [isSelfAssigned]);

  if (Object.keys(roleplayView).length === 0) return null;
  return (
    <div
      className={`${styles.description_header} ${
        isForSubmitView ? styles.description_header_submit : ''
      }`}
    >
      <div>
        <div className={styles.description_header_title}>{!leadView ? label : 'Assigned'}</div>
        <div className={styles.avatar}>
          {Organization.isRep() && isSelfAssigned ? null : (
            <>
              <Avatar
                className={styles.img}
                alt=""
                src={
                  !leadView
                    ? roleplayView?.assigned_by_user.profile_pic
                    : roleplayView?.user.profile_pic
                }
              >
                {!leadView
                  ? User.getInitial(roleplayView?.assigned_by_user)
                  : User.getInitial(roleplayView?.user)}
              </Avatar>

              <h4>
                {!leadView
                  ? User.getUserName(roleplayView?.assigned_by_user)
                  : User.getUserName(roleplayView?.user)}
              </h4>
            </>
          )}
        </div>
      </div>
      <div>
        <div className={styles.description_header_title}>Due Date</div>
        <h4 style={{ marginTop: '1rem' }}>
          {format(parseISO(roleplayView?.deadline), 'MMM dd, yyyy')}
        </h4>
      </div>
    </div>
  );
};

export default RoleplayHeader;
